import React from "react";

import {
  handleDeployStaleAssetFailure,
  isChunkLoadFailureReason,
} from "../helpers/deployStaleAssetRecovery";

/**
 * Catches failed React.lazy / chunk load errors so Suspense is not left
 * spinning forever when deploy-stale recovery is exhausted.
 */
export class DeployAssetErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { deployAssetFailed: false };
  }

  static getDerivedStateFromError(error) {
    if (isChunkLoadFailureReason(error)) {
      return { deployAssetFailed: true };
    }
    return null;
  }

  componentDidCatch(error) {
    if (!isChunkLoadFailureReason(error)) {
      return;
    }
    const { reportExhausted } = this.props;
    handleDeployStaleAssetFailure({ reportExhausted });
  }

  render() {
    if (this.state.deployAssetFailed) {
      // Imperative error screen is mounted by handleDeployStaleAssetFailure.
      return null;
    }
    return this.props.children;
  }
}
